<template>
  <ValidationProvider
    :rules="rules"
    :custom-messages="customMessages"
    tag="div"
    :name="name"
    v-slot="{ errors }"
    ref="provider"
  >
    <AGCLabel v-if="label" :required="required" id="brc">
      <slot>{{ label }}</slot>
      <template v-slot:subLabel>
        <slot name="subLabel">{{ subLabel }}</slot>
      </template>
    </AGCLabel>
    <BusinessRegistrationCertificate
      v-model="inputVal"
      :label="label"
      :disabled="disabled"
      id="brc"
    ></BusinessRegistrationCertificate>
    <b-form-invalid-feedback :state="state(errors)">
      {{ errors[0] }}
    </b-form-invalid-feedback>
  </ValidationProvider>
</template>

<script>
import { BFormInvalidFeedback } from 'bootstrap-vue';
import BusinessRegistrationCertificate from '@/components/BusinessRegistrationCertificate.vue';
import agcFormElementMixin from '../../mixins/agc-form-element';

export default {
  mixins: [agcFormElementMixin],
  components: {
    BusinessRegistrationCertificate,
    BFormInvalidFeedback,
  },
};
</script>

<style lang="scss" scoped></style>
